import React, { useContext } from 'react';
import { get, set } from 'lodash';

import { AnswerDropdownMediumWidth } from 'src/presentation/components/pages/shared/SelectAnswerDropdown';
import FormContext from 'src/presentation/contexts/FormContext';

const AnswersDropdown = ({
  answerType,
  attr,
  description,
  label = 'Answer',
  language,
  placeholder = 'Select an Answer',
}) => {
  const { errors, updateState, workingState, resetError } = useContext(FormContext);

  const handleAnswerIdChanged = (answerId: string) => {
    resetError({ attr, errors });
    updateState(set({}, attr, answerId));
  };

  const currentAnswerId = get(workingState, attr);

  return (
    <AnswerDropdownMediumWidth
      answerType={answerType}
      attr={attr}
      className="answer-dropdown"
      currentAnswerId={currentAnswerId}
      data-aid={attr}
      description={description}
      fieldName={attr.replace('.', '_')}
      fitOpenerWidth={true}
      label={label}
      language={language}
      onAnswerIdChange={handleAnswerIdChanged}
      placeholder={placeholder}
      showEditLink
    />
  );
};

export default AnswersDropdown;
